import { render, staticRenderFns } from "./clientRegisteCerticate.vue?vue&type=template&id=7a96ee98&scoped=true"
import script from "./clientRegisteCerticate.vue?vue&type=script&lang=js"
export * from "./clientRegisteCerticate.vue?vue&type=script&lang=js"
import style0 from "./clientRegisteCerticate.vue?vue&type=style&index=0&id=7a96ee98&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a96ee98",
  null
  
)

export default component.exports